import isArray from './is-array';
import isString from './is-string';
function endsWith(arr, e) {
  return isArray(arr) || isString(arr) ? arr[arr.length - 1] === e : false;
}
export default endsWith;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/ends-with.js
// module id = 54
// module chunks = 0